import React from 'react';
import { motion } from 'framer-motion';
export function UniqueMechanism() {
  return <section className="w-full bg-[#2D8C5A] py-16 md:py-20 px-6" data-id="element-90">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center" data-id="element-91">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-92">
          Protocolo de "Re-seteo de Territorio"
        </h2>
        <p className="text-xl text-white/90 mb-6 leading-relaxed" data-id="element-93">
          No es un manual de entrenamiento, es una intervención biológica.
        </p>
        <p className="text-lg text-white/80 leading-relaxed" data-id="element-94">
          En lugar de pelear contra el instinto de tu gato, usamos la etología
          felina para hackear sus señales de propiedad. Eliminamos la "huella
          química" con enzimas y re-mapeamos tu hogar para que la bandeja sea,
          por instinto, el único lugar lógico para su cerebro.
        </p>
      </motion.div>
    </section>;
}